/* eslint-disable max-len */
/* eslint-disable react/jsx-curly-brace-presence */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import filteredObjectsSelector from 'functions/filteredObjectsSelector'
import { concatNames } from 'functions/contact'
import { getLinkTypeByKey } from 'functions/mediaLink'
import currencyFormat from 'functions/currencyFormat'

import * as campaignProposalActions from 'agency/redux/modules/campaignProposal'

import Button from 'components/Button'

import EditingNavBar from 'agency/digital_renderer/components/EditingNavBar'
import RealhubFooter from 'components/RealhubFooter'
import ReviewsWrapper from 'agency/digital_renderer/components/ReviewsWrapper'
import ToggleableSection from 'agency/digital_renderer/components/ToggleableSection'
import filterComparables from 'agency/digital_renderer/utils/filterComparables'

import DatabaseImage from './assets/database.jpg'
import OurVisionImage from './assets/vision.jpg'
import InterestsFirstImage from './assets/interests_first.jpg'
import InternationalImage from './assets/international.jpg'
import StrategiesImage from './assets/strategies.jpg'

import BuyerProfiles from './components/BuyerProfiles'
import CampaignQuotes from './components/CampaignQuotes'
import ColumnTwo from './components/ColumnTwo'
import Comparables from './components/Comparables'
import CustomSections from './components/CustomSections'
import Download from './components/Download'
import Footer from './components/Footer'
import Header from './components/Header'
import KeyFeatures from './components/KeyFeatures'
import Marketing from './components/Marketing'
import Pricing from './components/Pricing'
import Reviews from './components/Reviews'
import SaleMethod from './components/SaleMethod'
import StickyLogo from './components/StickyLogo'
import TextOnly from './components/TextOnly'
import Timeline from './components/Timeline'
import Welcome from './components/Welcome'

import styles from './styles.scss'

const renderAgentLinks = (agent, mediaLinks) => {
  if (agent.media_links && agent.media_links.length){
    return (
      <div style={{ marginTop: 15 }}>
        {agent.media_links.map((mediaLinkId) => {
          const mediaLink = mediaLinks[mediaLinkId] || {}

          return (
            <Button
              href={mediaLink.url}
              key={mediaLink.id}
              text={getLinkTypeByKey(mediaLink.link_type)}
              size="medium"
              style={{ backgroundColor: '#ff4637', borderColor: '#ff4637', marginRight: 5 }}
              target="_blank"
            />
          )
        })}
      </div>
    )
  }

  return null
}

class TheAgency extends Component {
  _renderAgents = () => {
    const { agents, campaign, mediaLinks } = this.props

    if (!campaign.agents){
      return null
    }

    return campaign.agents.map((agentId, index) => {
      const agent = agents[agentId] || {}
      return [
        <ColumnTwo
          key={agent.id}
          bodyText={(
            <span>
              {agent.profile}
              {renderAgentLinks(agent, mediaLinks)}
            </span>
)}
          greyBackground
          imageUrl={agent.default_image_large}
          reversed={index % 2 === 1}
          title={agent.full_name}
        />,
        <ReviewsWrapper agent={agent} key={`reviews-${agent.id}`} render={params => <Reviews {...params} />} />,
      ]
    })
  }

  render(){
    const {
      agents,
      artworks,
      brand,
      campaign,
      campaignComparables,
      campaignProposal,
      campaignProposal: {
        commission_fee, commission_structure, list_price_max, list_price_min,
      },
      campaignSaleMethod,
      contacts,
      dashboardSettings,
      editing,
      images,
      updateCampaignProposal,
    } = this.props

    const marketComparables = filterComparables(campaignComparables, 'market')
    const agencyComparables = filterComparables(campaignComparables, 'agency')
    const artwork = artworks[campaignProposal.artwork] || {}
    const contactCount = Object.keys(contacts).length

    return (
      <div className={styles.root}>
        <EditingNavBar
          callbacks={{ updateCampaignProposal }}
          campaignProposal={campaignProposal}
          dataSource={campaignProposal}
          dataSourceType="CampaignProposal"
          editing={editing}
          redirect={dashboardSettings.redirect}
        />

        <StickyLogo brand={brand} />

        <Header
          campaign={campaign}
          campaignProposal={campaignProposal}
          images={images}
          vendorName={contactCount > 2 ? null : concatNames(contacts)}
        />

        <Download
          artwork={artwork}
          text="We've prepared a comprehensive print document that outlines the following content in further detail."
        />

        <TextOnly
          title="Brands don't sell houses, people do."
          text={`The Agency was founded on the basis that the old franchise model and cost structure was inefficient in today's modern marketplace.

          With digital and social media replacing shop fronts and newspapers, an Agent’s relationship is critical in negotiating and securing the right result.`}
        />

        <Welcome campaignProposal={campaignProposal} />

        <KeyFeatures campaign={campaign} />

        <SaleMethod campaignSaleMethod={campaignSaleMethod} />

        <BuyerProfiles campaign={campaign} />

        <ColumnTwo
          bodyText={`Bringing together the most talented people in real estate, we're here to change the way you experience property.
          
            The Agency’s innovative model empowers our people to embrace opportunities for the benefit of our clients. We have the freedom and support to do things differently, to achieve better results and deliver a more rewarding experience.
            
            As a national group, our network of offices around the country works collaboratively to ensure our buyers and sellers enjoy every advantage in the marketplace. With four vertically integrated pillars including Residential Sales, Project Marketing, Property Management and Finance, The Agency supports clients in every facet of their real estate journey.
            
            We harness the power of national and international networking, database resourcing and cross-selling, making clever use of market-leading technology in the process. In real estate, experience, innovation and integrity are the foundations for building trust and achieving results above the expected.`}
          greyBackground
          imageUrl={OurVisionImage}
          title="Our vision behind the brand"
        />

        <ColumnTwo
          bodyText={`Whether you're selling or buying, you'll have the best Property Partners working with and for you, operating with integrity and transparency. All of the decisions we make are made with your best interests at heart. We don't take shortcuts on performance, we give informed advice and we focus solely on what’s beneficial for you, giving your property the very best chance in the market.

            We understand that selling your property is a major decision, one that is often linked to other changes in your life. When we partner with you, you can rest assured it will be a seamless, stress-free process.

            We'll help you make the right decisions by sharing our considerable knowledge, expertise and market insight. You’ll be provided with facts to back up all of our recommendations – facts about recent sales in your area, the value of your property, current market conditions and the level of interest in your property.`}
          imageUrl={InterestsFirstImage}
          reversed
          title="Putting your interests first"
        />

        <ColumnTwo
          bodyText={`We firmly believe that it's people that sell properties, not brands. The Agency has the combined strength of some of the most experienced, passionate Property Partners in the country working cohesively, sharing their talents and expertise. That's years and years of transactions, successfully weathering the market's many ups and downs and all of the different scenarios that can possibly unfold.

            We draw on this considerable knowledge pool to deliver bespoke strategies that work. It's about listening intently to your needs and tailoring a campaign that's perfect for you and your property. Understanding your goals is paramount to achieving them.

            We know where to find the right buyers for your property and how to access them. Our dedicated marketing and advertising team creates comprehensive campaigns across the most effective channels to make sure we reach every single one of them.`}
          greyBackground
          imageUrl={StrategiesImage}
          title="Proven strategies to achieve desired results"
        />

        {!!list_price_min && !!list_price_max && (
          <Pricing
            bodyText={`In offering our opinion of the value of your property we take into account a number of important elements:

              • Recent sale of similar properties in the area
              • Overall condition and presentation of the property
              • Location, aspect and views (if applicable)
              • Current state of the property market
              
              It is our opinion that the current market value for ${campaign.address}, ${
              campaign.suburb_name
            } lies in the range of
              ${currencyFormat(list_price_min, '$0,0')} to ${currencyFormat(
              list_price_max,
              '$0,0',
            )}, possibly higher with a premium buyer.`}
            columnRightData={[
              {
                key: 'low',
                title: 'Lowest Price',
                value: currencyFormat(list_price_min, '$0,0'),
              },
              {
                key: 'high',
                style: { marginTop: 15 },
                title: 'Highest Price',
                value: currencyFormat(list_price_max, '$0,0'),
              },
            ]}
            title="Our price recommendation"
          />
        )}

        {this._renderAgents()}

        <Comparables
          brand={brand}
          campaign={campaign}
          campaignComparables={marketComparables}
          title="Comparable sales"
        />

        <Comparables
          brand={brand}
          campaign={campaign}
          campaignComparables={agencyComparables}
          title={campaign.agents && campaign.agents.length === 1 ? 'My recent sales' : 'Our recent sales'}
        />

        <ToggleableSection sectionId="marketing-showcase">
          <Marketing />
        </ToggleableSection>

        <ColumnTwo
          bodyText={`In bringing together industry leaders, we combine their extensive networks and their honed ability to successfully match people to properties. The Agency's advantage is our centralised website, providing one comprehensive platform to showcase all of our properties across the country. This exposes our listings to a broader range of buyers who might be encouraged to move to or invest in other areas.

            In addition to showcasing your property on our site, we have close relationships with all the major online advertising platforms such as domain.com.au and realestate.com.au, partnering with them to ensure your property gets major exposure.

            Having one centralised database network across all our offices is an invaluable resource for our Property Partners and our clients. We strategically use this database to directly market properties to potential buyers worldwide who are active in the market, often finding buyers off-market. Similarly, we cleverly use this technology to provide buyers with greater access to information to help them make more astute buying decisions.`}
          imageUrl={DatabaseImage}
          title="Database & online marketing"
        />

        <ColumnTwo
          bodyText={`We harness every opportunity to engage with the lucrative international market – both expat buyers and foreign investors – through web and database marketing and often a presence on the ground.

            With Australia considered such a strong, stable property investment prospect, this demographic is an important target market. Our reach is worldwide, especially throughout Asian countries such as China and Singapore which are well-known Australian investors, as well as North America, where many of our international buyers hail from.

            It's our business to nurture these relationships and learn the cultural nuances and unique buyer behaviour of these markets.`}
          imageUrl={InternationalImage}
          reversed
          title="International reach"
        />

        <ToggleableSection sectionId="national-marketing">
          <TextOnly
            title="National marketing"
            text={[
              <span key="agency">
                <span style={{ fontSize: 20 }}>theagency.com.au</span>
                <p style={{ marginBottom: 30 }}>
                  The Agency&apos;s centralised website showcases all of our listings right across the country to a
                  captive domestic, national and international audience. With all of our traffic coming through the one
                  site, we have the ability to market properties to a broader audience, often encouraging investment
                  from people viewing properties in areas they may not otherwise have explored.
                </p>
              </span>,
              <span key="rea">
                <span style={{ fontSize: 20 }}>realestate.com.au</span>
                <p style={{ marginBottom: 30 }}>
                  realestate.com.au is Australia&apos;s leading property portal, with an average of more than 3 million
                  visitors each month across web and mobile. We have an excellent established relationship with this
                  resource, making it one of the most invaluable marketing essentials for your property.
                </p>
              </span>,
              <span key="domain">
                <span style={{ fontSize: 20 }}>domain.com.au</span>
                <p style={{ marginBottom: 30 }}>
                  Domain is Australia&apos;s second major real estate portal, and has approximately 2 million unique
                  browsers each month, exposing your property to a vast national and international pool of buyers.
                  Domain&apos;s personalised reporting tools and ability to track all valuable phone and email leads
                  makes it an important resource.
                </p>
              </span>,
              <span key="portals">
                <span style={{ fontSize: 20 }}>Additional portals</span>
                <p>
                  Along with our site and the main real estate portals, we have established relationships with a number
                  of additional sites. Where beneficial, we can customise your marketing campaign to include other
                  national and international sites to tap into your target market and cover all of our marketing bases.
                </p>
              </span>,
            ]}
          />
        </ToggleableSection>

        <CustomSections campaignProposal={campaignProposal} editing={editing} />

        <CampaignQuotes campaignProposal={campaignProposal} />

        {commission_fee && (
          <Pricing
            bodyText={`When you select The Agency, our commitment to a successful sale of your home is guaranteed.

              This fee includes but is not limited to the following services:

              • Project management of any proposed works
              • Implementation of a custom designs selling strategy
              • Servicing and handling of all enquiries
              • Attending all private appointment and open house inspections
              • Organising and attending building and pest inspections
              • Negotiating with all interested buyers
              • Handling the exchange of contracts`}
            columnRightData={[
              {
                key: 'commission',
                title: 'Commission',
                value: `${commission_fee}%`,
                bodyText: commission_structure,
              },
            ]}
            title="Our selling fees"
          />
        )}

        <Timeline campaign={campaign} />

        <TextOnly
          title="The Agency difference"
          text="We hope you've gained some insight into The Agency's unique culture, service ethos and commitment to our clients. Our aim is to elevate your sales results and provide an enjoyable experience along the way, utilising our considerable resources and national network. With a team of experienced Property Partners who love what they do, we look forward to being of service to you."
        />

        <Download artwork={artwork} text="Don’t forget to download the PDF for further information." />

        <Footer agents={agents} brand={brand} campaign={campaign} />

        <RealhubFooter dark link="http://www.realhub.com.au/proposals" style={{ backgroundColor: '#252524' }} />
      </div>
    )
  }
}

TheAgency.propTypes = {
  agents: PropTypes.object.isRequired,
  artworks: PropTypes.object.isRequired,
  brand: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  campaignComparables: PropTypes.object.isRequired,
  campaignProposal: PropTypes.object.isRequired,
  campaignSaleMethod: PropTypes.object.isRequired,
  contacts: PropTypes.object.isRequired,
  dashboardSettings: PropTypes.object,
  editing: PropTypes.bool,
  images: PropTypes.object.isRequired,
  mediaLinks: PropTypes.object.isRequired,
  updateCampaignProposal: PropTypes.func.isRequired,
}

function mapStateToProps(state, props){
  const { campaign } = props
  const { artworks, mediaLinks, agents } = state.entities

  return {
    dashboardSettings: window.dashboardSettings || {},
    agents,
    artworks,
    campaignComparables: filteredObjectsSelector(state, 'campaignComparables', 'campaign_id', campaign.id),
    mediaLinks,
  }
}

const mapDispatchToProps = {
  updateCampaignProposal: campaignProposalActions.updateCampaignProposal,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TheAgency)
